import type { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import type { SubscribeFormValues } from '../SubscribeFormSchema';

interface Props {
  register: UseFormRegister<SubscribeFormValues>;
  setValue: UseFormSetValue<SubscribeFormValues>;
  watch: UseFormWatch<SubscribeFormValues>;
  label1?: string | null;
  label2?: string | null;
  header?: string | null;
}

/**
 * Two optional, mutually-exclusive opt-in checkboxes (replaces the legacy
 * `.js-exclusive-checkbox` vanilla JS). Checking one unchecks the other.
 */
export default function ExtraCheckboxes({ register, setValue, watch, label1, label2, header }: Props) {
  if (!label1 && !label2) return null;

  const checkbox1 = watch('extraCheckbox1');
  const checkbox2 = watch('extraCheckbox2');

  return (
    <>
      {header && (
        <div style={{ margin: '1em 0 0.75em 0' }}>
          <strong>{header}</strong>
        </div>
      )}
      <div className="form-row">
        <div className="form-checkbox" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {label1 && (
            <>
              <input
                id="subscribe_extraCheckbox1"
                type="checkbox"
                {...register('extraCheckbox1')}
                checked={!!checkbox1}
                onChange={(e) => {
                  setValue('extraCheckbox1', e.target.checked);
                  if (e.target.checked) setValue('extraCheckbox2', false);
                }}
              />
              <label htmlFor="subscribe_extraCheckbox1">{label1}</label>
            </>
          )}
          {label2 && (
            <>
              <input
                id="subscribe_extraCheckbox2"
                type="checkbox"
                {...register('extraCheckbox2')}
                checked={!!checkbox2}
                onChange={(e) => {
                  setValue('extraCheckbox2', e.target.checked);
                  if (e.target.checked) setValue('extraCheckbox1', false);
                }}
              />
              <label htmlFor="subscribe_extraCheckbox2">{label2}</label>
            </>
          )}
        </div>
      </div>
    </>
  );
}
